import getConfig, { defaultPromiseState } from "~/config";
import axios from '~/axios';
import identify from "~/identify";
import invert from 'lodash/invert';
import { reportError } from "~/lib/reportErrors";

import debounce from "lodash/debounce";
const debouncedReportError = debounce(reportError, 100, { leading: true })


export default function createPromiseThunk({
   func,
   name,
   defaultValue = undefined,
   customProps,
   configGetter = getConfig,
   successHandler = () => {},
   actions
}) {
    let started_at = `${name}_started`,
        successfull = `${name}_successfull`,
        errored = `${name}_errored`,
        canceled = `${name}_canceled`;

    let promiseState = defaultPromiseState;

    actions = {
        setStarted: (customParams = {}) => ({ type: started_at, ...customProps, ...customParams }),
        setValue: (value, customParams = {}) => ({ type: successfull, value: value, ...customProps, ...customParams }),
        setErrored: (error, customParams = {}) => ({ type: errored, error: error, ...customProps, ...customParams }),
        setCanceled: (customParams = {}) => ({ type: canceled, ...customProps, ...customParams }),
        ...actions
    };

    let types = {
        PENDING: started_at,
        SUCCESS: successfull,
        ERROR: errored,
        CANCELED: canceled
    };

    let typeNames = invert(types);

    return {
        actions,
        types,
        typeNames,
        initialState: {
            ...promiseState,
            value: defaultValue
        },

        execute: (parameters = {}, customParams = {}) => async (dispatch, getState) => {
            dispatch(actions.setStarted(customParams));

            let handlerParams = {
                dispatch,
                getState,
                getConfig: configGetter,
                customParams,
                ...actions,
                ...parameters,
            };

            try {
                let value = await func(handlerParams);

                if((typeof successHandler({...handlerParams, value}) !== 'undefined')) {
                    return value;
                }

                dispatch(actions.setValue(value, customParams));

                return value;

            } catch(err) {
                console.log('oh noes', err);
                let errMessage = err.message;

                if(axios.isCancel(err)) { return dispatch(actions.setCanceled(customParams)); }
                if(!errMessage) { errMessage = JSON.stringify(err); }
                
                debouncedReportError(err);
                dispatch(actions.setErrored(errMessage, customParams));
            }
        },

        reduce: (state, action) => {
            switch(action.type) {
                case started_at:
                    return {
                        ...state,
                        status: identify.STATUS_STARTED,
                        started_at: Date.now()
                    };
                case successfull:
                    return {
                        ...state,
                        finished_at: Date.now(),
                        status: identify.STATUS_SUCCESS,
                        value: action.value,
                    };
                case errored:
                    return {
                        ...state,
                        status: identify.STATUS_ERRORED,
                        finished_at: Date.now(),
                        error: action.error
                    };
                case canceled:
                    return {
                        ...state,
                        status: identify.STATUS_CANCELED,
                        canceled_at: Date.now(),
                    };
            }

            return state;
        },
    };
}